import { React, classNames } from '@digsup/core-ui';
import PropTypes from 'prop-types';
import './Wrapper.scss';

const cx = classNames;

const WrapperWithRef = ({
  gutter,
  forwarderRef,
  className,
  children,
  ...props
}) => {
  const classes = cx(
    'l-wrapper',
    {
      [`l-wrapper--gutter-${gutter}`]: gutter,
    },
    className,
  );

  return (
    <div className={classes} ref={forwarderRef} {...props}>
      {children}
    </div>
  );
};

export const Wrapper = React.forwardRef((props, ref) => (
  <WrapperWithRef {...props} forwarderRef={ref} />
));

Wrapper.propTypes = {
  /**
   * Horizontal padding
   */
  gutter: PropTypes.oneOf(['none', 'small', 'medium', 'large']),
  /**
   * Extend the classNames applied to the component
   */
  className: PropTypes.string,
};

Wrapper.defaultProps = {
  gutter: 'medium',
  className: '',
};
